import type { ReactNode } from 'react';

interface PageStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

/**
 * Neutral full-page message used for loading, empty and error states so those
 * three cases look and behave the same everywhere.
 */
export function PageState({ title, description, action }: PageStateProps) {
  return (
    <div className="flex min-h-[60dvh] flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      {description !== undefined && (
        <p className="text-fg-muted max-w-prose text-base">{description}</p>
      )}
      {action}
    </div>
  );
}
